export default "__VITE_ASSET__CTui96LL__"